import { CSSProperties, ReactNode } from "react";

export type ReceivedProps = {
  isOpen: boolean;
  content: string | ReactNode;
  isSubmitting?: boolean;
  onCancel?: () => void;
  onOk: () => void;
  width?: number;
  okText?: string;
  cancelText?: string;
  className?: string;
  zIndex?: number;
  cancelButtonStyle?: CSSProperties;
  cancelButtonClassName?: string;
  okButtonClassName?: string;
  wrapClassName?: string;
};

const useModalConfirm = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useModalConfirm>;

export default useModalConfirm;
